export default __webpack_public_path__ + "static/media/blue-tick.018acc9b.svg";